module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-ico-01-blue.86e05bf7.svg";